<div [style.display]="'block'">
  <div>
    <mat-form-field class="w-100">
      <textarea class="ta-quote-remarks" matInput placeholder="Remarks" [maxLength]="maxIncidentDescriptionLength"
        [(ngModel)]="bookingQuote.remarks"></textarea>
      <small class="form-text text-muted">
        <code>{{ bookingQuote.remarks?.length || 0 }}</code> of
        <code>{{ maxIncidentDescriptionLength }}</code> characters
      </small>
    </mat-form-field>

    <mat-form-field class="w-100">
      <mat-label>Number of days after quotes expire</mat-label>
      <input class="ta-quote-numberofdaysafterexpire" matInput (keypress)="numbersOnly($event)" type="number" min="0"
        [maxLength]="2" placeholder="" [(ngModel)]="bookingQuote.expiryDays">
    </mat-form-field>

    <div style="text-align: left;">
      <mat-checkbox class="ta-quote-isalert" [(ngModel)]="bookingQuote.isAlert" color="primary">
        Review needed
      </mat-checkbox>
    </div>
    <br>
    <div *ngIf="isSign" class="margin_20" style="border:0px solid rgb(255, 253, 253) !important;">
      <div *ngIf="isSign && !signatureImage">
        <span>
          <span style="color: red;" *ngIf="isSignatureRequired">*signature is required </span>
          <br>
          <app-signature-pad
            #signature
            style="background-color: white !important;"
            [height]="200"
            [minWidth]="5"
            backgroundColor="#ffffff"
            (drawStart)="drawStart()"></app-signature-pad>
          <br>

        </span>
        <button mat-button class="text-white btn btn-success" (click)="drawComplete()">Done</button>
        &nbsp;
        <button mat-button class="text-white btn btn-warning pull-right" (click)="clear()">Clear</button>
      </div>
      <div *ngIf="signatureImage">
        <app-signature-pad
          [readonly]="true"
          [height]="200"
          [value]="signatureImage"
          backgroundColor="#ffffff"></app-signature-pad>
        <div>
          <br>
          <button mat-button class="ta-quote-resign text-white btn btn-warning" (click)="resign()">
            Re-Sign
          </button>
        </div>
      </div>
      <br>
    </div>
    <br>
    <div>
      <button mat-button
        class="mat-mdc-button-RedBackground-WhiteText ta-quote-cancel magin_5 text-white btn btn-danger"
        (click)="cancel()">Cancel</button>
      <button [disabled]="isSign" mat-button class="ta-quote-sign magin_5 text-white btn btn-info"
        (click)="sign()">Sign</button>
      <button [disabled]="isSignatureRequired" mat-button
        [ngClass]="'ta-quote-finish magin_5 text-white btn btn-'+globals.colorTheme"
        (click)="finishQuote()">{{showFarmAndFields? 'Quote Single':'Quote'}}</button>
      <button [disabled]="isSignatureRequired" mat-button *ngIf="showFarmAndFields"
        class="mat-stroked-button-WhiteBackground-GreenText ta-quote-split magin_5 color_green"
        (click)="splitFinishQuote()">Quote Split</button>
    </div>
  </div>
</div>